'use strict';

var React = require('react'),
    IconMixin = require('../../mixins/IconMixin');

var FacebookIcon = React.createClass({
  mixins: [IconMixin],

  renderSVG: function (size) {
    switch (size) {
    case 'small':
      return '<path d="M18 17.17V0.83C18 0.37 17.63 0 17.18 0h-1.46H2.29 0.82C0.37 0 0 0.37 0 0.83v14.85l0 1.49C0 17.63 0.37 18 0.82 18h9.08v-7.23H7.56v-2.49h2.35V5.58c0-1.62 1.45-2.71 2.61-2.71h2.63v2.27h-1.21c-0.6 0-1.39 0.49-1.39 1.1v2.05h2.37v2.49H12.54V18h3.17 1.47C17.63 18 18 17.63 18 17.17z"/>';
    case 'medium':
      return '<path d="M32 30.52V1.48C32 0.66 31.35 0 30.54 0h-2.6H4.06 1.46C0.66 0 0 0.66 0 1.48v26.39L0 30.52C0 31.34 0.65 32 1.46 32h16.15V19.15h-4.17v-4.43h4.17V9.92c0-2.88 2.57-4.82 4.64-4.82h4.67v4.03h-2.15c-1.06 0-2.47 0.88-2.47 1.95v3.65h4.2v4.43h-4.2V32h5.64 2.6C31.35 32 32 31.34 32 30.52z"/>';
    case 'large':
      return '<path d="M48 45.78V2.23C48 1 47.02 0 45.81 0h-3.91H6.1 2.19C0.98 0 0.01 0.99 0 2.21v39.59L0 45.78C0 47.01 0.98 48 2.19 48h24.22V28.73h-6.25V22.09h6.25v-7.21c0-4.32 3.86-7.22 6.97-7.22h7v6.04h-3.23c-1.59 0-3.71 1.31-3.71 2.93v5.47h6.31v6.64h-6.31V48h8.47 3.91C47.02 48 48 47 48 45.78z"/>';
    }
  }
});

module.exports = FacebookIcon;



/** WEBPACK FOOTER **
 ** ./atoms/icons/Facebook.jsx
 **/